module.exports = __webpack_public_path__ + "static/media/bank-charges.3bd49a3a.svg";